import React, { useCallback } from "react";
import styled from "styled-components";
import Button from "../Shared/Button";
import {useDispatch, useSelector} from "react-redux";
import {
    getClientProfile,
    getInvestmentExpOptions,
    getInvestmentGoalOptions,
    getIsEditAboutYourselfData, getUpdatedGender, getUpdatedInvestmentGoals, getUpdatedInvExpLevel
} from "../../redux/profile/selectors";
import {
    saveOrUpdateClientProfile, setIsEditAboutYourselfData,
    setUpdatedGender, setUpdatedInvestmentGoals,
    setUpdatedInvExpLevel
} from "../../redux/profile/slice";
import Dropdown from "../Shared/Dropdown";
import {ProfileBeaconCheckbox} from "../Shared/ProfileBeaconComponents";
import { useCookies } from 'react-cookie';
import _ from "lodash";
import {isInternal} from "../../utils/api";
const StyledAboutYourselfInfo = styled.div`
  padding: 32px 40px;
  background-color: #fff;
  margin-top: 24px;
  @media only screen and (max-width: 480px) {
    margin-top: 16px;
  }
  @media (max-width: 768px){
    padding: 24px;
    margin-top: 16px;
  }
`;

const StyledHeader = styled.div`
  border-bottom: 1px solid #bec3c8;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    font-size: 18px;
    letter-spacing: 0.02px;
  }
`;

const StyledHeaderText = styled.div`
  @media (max-width: 767px) {
    width: 149px;
  }
  @media (min-width: 768px) and (max-width: 1240px){
    width: 180px;
  }
`;
const StyledLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledContainer = styled.div`
  margin-top: 16px;
  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

const StyledTitleContainer = styled.div`
  padding: 14px 0;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  text-align: left;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 0 0 16px 0;
    line-height: 1.5;
    :last-child {
      padding-bottom: 0;
    }
  }
`;

const StyledDropdownContainer = styled.div`
  padding: 14px 0;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  text-align: left;
  color: #3b4b59;
  @media (max-width: 768px) {
    align-items: center;
    font-size: 16px;
    padding: 0 0 16px 0;
    line-height: 1.5;
    :last-child {
      padding-bottom: 0;
    }
  }
`;

const StyledValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledTitle = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
`;

const StyledDropdownTitle = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  @media (min-width: 641px) and (max-width: 768px) {
    width: 79px;
  }
  @media (max-width: 640px) {
    width: 130px;
  }
  @media (min-width: 769px) and (max-width: 1240px){
    width: 140px;
  }
`;

const StyledCheckboxTitle = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  @media (max-width: 768px) {
    width: 79px;
  }
  @media (max-width: 640px) {
    width: 93px;
  }
  @media (min-width: 769px) and (max-width: 1240px){
    width: 140px;
  }
`;

const StyledValue = styled.div`
  font-weight: var(--beacon-font-weight-bold);
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  text-align: right;
  @media (max-width: 768px){
    width: 170px;
  }
`;

const StyledCheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 217px;
  @media (max-width: 640px) {
    width: 170px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 200px;
  }
`;


const StyledCheckbox = styled(ProfileBeaconCheckbox)`
  --beacon-form-label-font-size: 18px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px){
    --beacon-form-label-font-size: 14px;
  }
`;

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 640px) {
    flex-direction: column-reverse;
    row-gap: 20px;
    align-items: center;
  }
`;

const StyledLinkButton = styled.div`
margin-right: 16px;
  @media (max-width: 640px){
    margin-right: 0;
  }
`;
export const AboutYourselfCard = () => {

    const dispatch = useDispatch();
    const isEditMode = useSelector(getIsEditAboutYourselfData);
    const [cookies, setCookies] = useCookies();
    const uberId = cookies["cl-uber"];
    const clientProfile = useSelector(getClientProfile);
    const defaultGender = {
        typeName: 'Male',
        typeCd: 'MAL',
        typeId: 397
    };
    const defaultInvExpLevel = {
        typeName: 'Beginner',
        typeCd: 'BEG',
        typeId: 400
    };
    const gender = clientProfile?.genderType;
    const updatedGender = useSelector(getUpdatedGender);

    const investmentExperienceLevel = clientProfile?.financialExperienceLevelType;
    const updatedInvExpLevel = useSelector(getUpdatedInvExpLevel);
    const investmentExperienceOptions = useSelector(getInvestmentExpOptions);

    const investmentGoals = _.sortBy(clientProfile?.investmentsGoals, 'clientProfileInvestmentGoals.typeName');
    const investmentGoalOptions = _.sortBy(useSelector(getInvestmentGoalOptions), 'fullname');
    const updatedInvGoals = _.sortBy(useSelector(getUpdatedInvestmentGoals), 'clientProfileInvestmentGoals.typeName');

    const genderOptions = [
        {
            name: 'Male',
            value: 'MAL',
            id: 397
        },
        {
            name: 'Female',
            value: 'FEM',
            id: 398
        },
        {
            name: 'Prefer Not to Answer',
            value: 'PNA',
            id: 399
        }
    ]
    const invExpLevelsOptions = investmentExperienceOptions?.map((data: any) => {
        return {
            "name": data.fullname,
            "value": data.code.trim(),
            "id": data.valueIdentifier
        }
    })

    const handleEdit = () => {
        dispatch(setIsEditAboutYourselfData(true))
    }

    const handleGenderChange = (event: any) => {
        const updatedGender = {
            "typeId": genderOptions.find(element => element.value === event.target.value)?.id,
            "typeCd": event.target.value,
            "typeName": genderOptions.find(element => element.value === event.target.value)?.name
        }
        dispatch(setUpdatedGender(updatedGender));
    }
    const handleInvExpLevelChange = (event: any) => {
        const updatedInvExpLevel = {
            "typeId": invExpLevelsOptions.find((element: any) => element.value === event.target.value)?.id,
            "typeCd": event.target.value,
            "typeName": invExpLevelsOptions.find((element: any) => element.value === event.target.value)?.name
        }
        dispatch(setUpdatedInvExpLevel(updatedInvExpLevel));
    }

    const handleInvGoalChange = (event: any) => {
        if (event.target.checked) {
            const updatedGoal = {
                "clientProfileInvestmentGoals": {
                    "typeId": event.target.id,
                    "typeCd": event.target.value.trim(),
                    "typeName": event.target.label
                },
                "origUserId": "RWS", "origTimeStamp": "", "lastUpdatedUserId": "RWS", "lastUpdatedTimeStamp": ""
            }
            if (updatedInvGoals)
                dispatch(setUpdatedInvestmentGoals([updatedGoal, ...updatedInvGoals]))
            else
                dispatch(setUpdatedInvestmentGoals([updatedGoal]))
        } else {
            const updatedGoals = updatedInvGoals.filter((goal: any) => goal.clientProfileInvestmentGoals?.typeId !== event.target.id)
            dispatch(setUpdatedInvestmentGoals(updatedGoals))
        }
    }
    const handleSaveAbtYourselfData = useCallback((updatedGenderType, updatedInvExpLevelType, updatedInvGoals, clientProfile) => {
        let profileAlreadyExists = false;
        if (!(_.isEmpty(clientProfile)))
            profileAlreadyExists = true;
        let clientProfileAttributes = clientProfile?.attributes ? clientProfile?.attributes?.map((clientProfileAttribute: any) => {
            return {
                ...clientProfileAttribute,
                clientProfileEffectiveTimestamp: clientProfile.effectiveTimestamp == null ? "" : clientProfile.effectiveTimestamp,
                effectiveTimestamp: clientProfile.effectiveTimestamp == null ? "" : clientProfile.effectiveTimestamp,
                expirationTimestamp: clientProfile.expirationTimestamp == null ? "" : clientProfile.expirationTimestamp,
                date: clientProfileAttribute.date == null ? "" : clientProfileAttribute.date.toString(),
                value: clientProfileAttribute.value == null ? 0 : clientProfileAttribute.value,
                text: clientProfileAttribute.text == null ? "" : clientProfileAttribute.text,
                timestamp: clientProfileAttribute.timestamp == null ? "" : clientProfileAttribute.timestamp.toString(),
                indicator: clientProfileAttribute.indicator == null ? false : clientProfileAttribute.indicator,
                referenceType: clientProfileAttribute.referenceType == null ? 0 : clientProfileAttribute.referenceType,
                referenceValue: clientProfileAttribute.referenceValue == null ? 0 : clientProfileAttribute.referenceValue
            }
        }) : [];
        let profile = {
            uberId: uberId,
            genderType: updatedGenderType,
            financialExperienceLevelType: updatedInvExpLevelType,
            investmentsGoals: updatedInvGoals,
            attributes: clientProfileAttributes,
            effectiveTimestamp: "",
            expirationTimestamp: "",
            origUserId: "RWS",
            origTimeStamp: "",
            lastUpdatedUserId: "RWS",
            lastUpdatedTimeStamp: ""
        }
        dispatch(saveOrUpdateClientProfile({profile, profileAlreadyExists}))
    }, [dispatch]);

    const handleCancel = () => {
        dispatch(setIsEditAboutYourselfData(false))
        dispatch(setUpdatedGender(gender))
        dispatch(setUpdatedInvExpLevel(investmentExperienceLevel))
        dispatch(setUpdatedInvestmentGoals(investmentGoals))
    }

    const isSaveButtonEnabled = (gender == null && investmentExperienceLevel == null && (investmentGoals == null || investmentGoals.length == 0)) || !_.isEqual(gender,updatedGender) || !_.isEqual(investmentExperienceLevel,updatedInvExpLevel) || !_.isEqual(_.map(investmentGoals, o => _.pick(o, ['clientProfileInvestmentGoals'])),_.map(updatedInvGoals, o => _.pick(o, ['clientProfileInvestmentGoals'])));

    return (
        <StyledAboutYourselfInfo>
            <StyledHeader>
                <StyledHeaderText>Tell Us More About Yourself</StyledHeaderText>
                <StyledLinkContainer>
                    <Button variant="tertiary" isIcon={true} buttonTitle="Edit" onBeaconClick={() => !isInternal() && handleEdit()} disabled={isEditMode || isInternal()}/>
                </StyledLinkContainer>
            </StyledHeader>
            <StyledContainer>
                { isEditMode ?
                        <StyledDropdownContainer>
                            <StyledDropdownTitle>Gender</StyledDropdownTitle>
                            <Dropdown 
                              name="genderType"
                              hideDropdownLabel={true}
                              id={updatedGender ? updatedGender?.typeId : defaultGender.typeId}
                              value={updatedGender ? updatedGender?.typeCd :defaultGender.typeCd}
                              options={genderOptions} 
                              onInput={handleGenderChange}
                              label="gender type"
                              />
                        </StyledDropdownContainer>
                    :  <StyledTitleContainer className="blocked_data">
                        <StyledTitle>Gender</StyledTitle>
                        <StyledValue>{!_.isEmpty(gender) ? gender?.typeCd === "PNA" ? "Prefer Not to Answer" : gender?.typeName : "Not Entered"}</StyledValue>
                    </StyledTitleContainer>
                }
                { isEditMode ?
                        <StyledDropdownContainer>
                            <StyledDropdownTitle>Level of Investment Experience</StyledDropdownTitle>
                            <Dropdown 
                              name="investmentExperienceLevelType"
                              hideDropdownLabel={true}
                              id={updatedInvExpLevel ? updatedInvExpLevel?.typeId : defaultInvExpLevel.typeId}
                              value={updatedInvExpLevel ? updatedInvExpLevel?.typeCd : defaultInvExpLevel.typeCd}
                              options={invExpLevelsOptions} 
                              onInput={handleInvExpLevelChange}
                              label="Investment experience level type"
                              />
                        </StyledDropdownContainer>
                        :
                        <StyledTitleContainer className="blocked_data">
                            <StyledTitle>Level of Investment Experience</StyledTitle>
                            <StyledValue>{!_.isEmpty(investmentExperienceLevel) ? investmentExperienceLevel?.typeName : "Not Entered"}</StyledValue>
                        </StyledTitleContainer>
                }
                { isEditMode ?
                        <StyledTitleContainer>
                            <StyledCheckboxTitle>Topics That Interest You</StyledCheckboxTitle>
                            <StyledCheckboxContainer>
                                <>
                                    {updatedInvGoals ? investmentGoalOptions?.map((goal: any) => {
                                            return <StyledCheckbox
                                                name="investmentGoalsType"
                                                label={goal.fullname}
                                                id={goal.valueIdentifier}
                                                value={goal.code}
                                                checked={updatedInvGoals?.findIndex((item: any) => item.clientProfileInvestmentGoals?.typeCd == goal.code.trim()) !== -1}
                                                onInput={handleInvGoalChange}
                                            />
                                        }) :
                                        investmentGoalOptions?.map((goal: any) => {
                                            return <StyledCheckbox
                                                name="investmentGoalsType"
                                                label={goal.fullname}
                                                id={goal.valueIdentifier}
                                                value={goal.code}
                                                onInput={handleInvGoalChange}
                                            />
                                        })
                                    }
                                </>
                            </StyledCheckboxContainer>
                        </StyledTitleContainer>
                        :
                        <StyledTitleContainer className="blocked_data">
                            <StyledTitle>Topics That Interest You</StyledTitle>
                            { investmentGoals && investmentGoals.length > 0 ?
                            <StyledValueContainer>
                                <>
                                    {investmentGoals?.map((goal: any) => {
                                        return <StyledValue>{goal.clientProfileInvestmentGoals?.typeName}</StyledValue>
                                    })}
                                </>
                            </StyledValueContainer> :
                                <StyledValue>Not Entered</StyledValue> }
                        </StyledTitleContainer>
                }
                { isEditMode &&
                    <StyledButtonContainer>
                        <StyledLinkButton><Button variant="tertiary" isLink={true} buttonTitle="Cancel" onBeaconClick={()=>handleCancel()}/></StyledLinkButton>
                        <Button buttonTitle="Save" disabled={!isSaveButtonEnabled} onBeaconClick={()=> handleSaveAbtYourselfData(updatedGender ? updatedGender : defaultGender,
                            updatedInvExpLevel ? updatedInvExpLevel : defaultInvExpLevel, updatedInvGoals, clientProfile)}/>
                    </StyledButtonContainer>
                }
            </StyledContainer>
        </StyledAboutYourselfInfo>
    )
}